import { Checkbox, SelectInput, TextInput } from "@/components/ui/Field";
import {
  isBooleanSourceField,
  isMultiValueOperator,
  isOptionSourceField,
  type SourceFieldMeta,
  valueOptionsForRule,
} from "./behaviorRules";

/** Typabhängiges Wert-Control für Regel-Bedingungen (Sichtbarkeits- und Antwortregeln). */
export function RuleValueInput({
  value,
  sourceField,
  operator,
  label = "Wert",
  onChange,
}: {
  value: unknown;
  sourceField: SourceFieldMeta | null;
  operator: string;
  label?: string;
  onChange: (next: unknown) => void;
}) {
  if (isBooleanSourceField(sourceField)) {
    const selected = value === false || String(value) === "false" ? "false" : "true";
    return (
      <SelectInput label={label} value={selected} onChange={(e) => onChange(e.target.value === "true")}>
        <option value="true">true</option>
        <option value="false">false</option>
      </SelectInput>
    );
  }

  if (isOptionSourceField(sourceField)) {
    const options = valueOptionsForRule(sourceField, value);
    if (isMultiValueOperator(operator)) {
      const selected = Array.isArray(value)
        ? value.map((v) => String(v ?? "").trim()).filter(Boolean)
        : String(value ?? "").trim()
          ? [String(value).trim()]
          : [];
      const selectedSet = new Set(selected);
      return (
        <div>
          <span className="mb-1 block text-xs font-medium text-label-secondary">{label}</span>
          <div className="max-h-40 space-y-1 overflow-y-auto rounded-lg border border-separator px-2 py-1.5">
            {options.length === 0 ? (
              <p className="text-xs text-label-secondary">Keine Antwortoptionen am Quellfeld.</p>
            ) : (
              options.map((opt) => (
                <Checkbox
                  key={opt.value}
                  label={opt.label}
                  checked={selectedSet.has(opt.value)}
                  onChange={(e) => {
                    const next = new Set(selectedSet);
                    if (e.target.checked) next.add(opt.value);
                    else next.delete(opt.value);
                    onChange(options.map((option) => option.value).filter((entry) => next.has(entry)));
                  }}
                />
              ))
            )}
          </div>
        </div>
      );
    }

    const single = Array.isArray(value) ? String(value[0] ?? "") : String(value ?? "");
    return (
      <SelectInput label={label} value={single} onChange={(e) => onChange(e.target.value)}>
        <option value="">Bitte wählen …</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </SelectInput>
    );
  }

  const textValue = Array.isArray(value)
    ? value.map((entry) => String(entry ?? "")).join(", ")
    : typeof value === "string" || typeof value === "number"
      ? String(value)
      : value == null
        ? ""
        : JSON.stringify(value);
  return (
    <TextInput
      label={label}
      value={textValue}
      placeholder="Vergleichswert"
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
